import React, {memo} from "react";
import BaseModal from "./../BaseModal";
import {useDispatch, useSelector} from "react-redux";

import {CSSTransition, SwitchTransition} from "react-transition-group";

import {Modal} from "react-bootstrap";
import _ from "lodash";
import qs from "querystring";
import axios from "axios";
import {BASE_URL, ORDER_CHANGE_DELIVERY_TIME} from "../../../../../apis";
import {Swiper, SwiperSlide} from 'swiper/react';
import LoaderModals from "../../loaders/LoaderModals";
import SwiperCore, {Navigation, Scrollbar, A11y} from 'swiper';



import {handelCloseModalEditDateTime, handelToggleLoaderModal} from "../../../../../redux/actions/modals/editOrder/modalEditDateTime";
import {
    actionChangeActiveDayPostSchedule,
    actionChangeActiveSelectTablePostSchedule
} from "../../../../../redux/actions/modals/modalShoppingCard";
import {Button, Col, Row} from "react-bootstrap";
import {actionChangeSelectOrderModalInvoice} from "../../../../../redux/actions/modals/modalInvoice/modalInvoice"; 
import swal from 'sweetalert';


SwiperCore.use([Navigation, Scrollbar, A11y]);
const EditOrderDeliveryDateTimeModal = () => {
    const dispatch = useDispatch();


    const {days, activeDayPostSchedule, activeSelectTablePostSchedule} = useSelector(state => state.modalShoppingCard);
    const {statusShow, loader_modal} = useSelector(state => state.modalEditOrderDateTime);
    const {order} = useSelector(state => state.modalInvoice);
    const {token} = useSelector(state => state.user);

    
    const handleClose = () => {
        dispatch(handelCloseModalEditDateTime());
    };

    const onClickItemDay = (key) => {
        dispatch(actionChangeActiveDayPostSchedule(key));
    };

    const handelOnClickSelectTime = (time) => {
        if (time.selectable)
            dispatch(actionChangeActiveSelectTablePostSchedule(time));
    };

    const handleSubmit = () => {
        dispatch(handelToggleLoaderModal(true));

        callApiEditOrderDeliveryDateTime();
    };


    const callApiEditOrderDeliveryDateTime = () => {
        let data = {order: order.order, delivery_time: activeSelectTablePostSchedule.id, delivery_date: activeDayPostSchedule};
        
        axios({
            method: 'post',
            url: BASE_URL + ORDER_CHANGE_DELIVERY_TIME,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
            data: qs.stringify(data),
        }).then((response) => {
            dispatch(handelToggleLoaderModal(false));

            if(response.data.status === "ok") {
                let editOrder = order;
                editOrder.delivery_time = _(days.days).find((day, key) => key === activeDayPostSchedule).shamsi + " " + activeSelectTablePostSchedule.time;
                dispatch(actionChangeSelectOrderModalInvoice(editOrder));


                if(response.data.message !== undefined && response.data.message !== null)
                    swal({
                        text: response.data.message,
                        buttons: {
                            cancel: "باشه",
                        },
                        icon: "success",
                    }).then(function() {
                        dispatch(handelCloseModalEditDateTime());
                    });
                else
                    dispatch(handelCloseModalEditDateTime());
            }
            else if(response.data.status === "error")
                swal({
                        text: response.data.message,
                        buttons: {
                            cancel: "باشه",
                        },
                        icon: "error",
                    });
        }).catch((error) => {
            dispatch(handelToggleLoaderModal(false));
        });
    };

    const settingSwiper = {
        freeMode: true,
        spaceBetween: 5,
        breakpoints: {
            0: {slidesPerView: 3.5}
        }
    }

    return  (
        <React.Fragment>
            <BaseModal title='ویرایش زمان بندی ارسال'
                       show={statusShow}
                       dialogClassName={'modal-dialog-shopping-card-custom'}
                       handleClose={handleClose}>
                <Modal.Body>
                    {!loader_modal ?

                        days.days ?
                        <SwitchTransition mode={'out-in'}>
                            <CSSTransition
                                key={false}
                                addEndListener={(node, done) => {
                                    node.addEventListener("transitionend", done, false);
                                }}  >
                                <div className={"o-hidden"}>
                                    <div className={'anim-base-test'}>
                                        <React.Fragment>
                                            <div className={'mt-2'}>
                                                <div className={'swiper-day-modal-select-time'} dir={"ltr"}>
                                                    {_.size(days.days) > 0 &&
                                                    <Swiper {...settingSwiper}>
                                                        {_.map(days.days, (day, key) =>
                                                            <SwiperSlide key={key}>
                                                                <div
                                                                    className={`card-item-day-show-send ${activeDayPostSchedule === key ? 'select' : ''}`}
                                                                    onClick={() => onClickItemDay(key)}
                                                                >
                                                                    <div>
                                                                        <span>{day.title}</span>
                                                                    </div>
                                                                    <div>
                                                                        <span>{day.shamsi}</span>
                                                                    </div>
                                                                </div>
                                                            </SwiperSlide>
                                                        )}
                                                    </Swiper>
                                                    }
                                                </div>
                                                <ul className={'box-times-send-modal-select-time'}>
                                                    {/*{((typeof days.days !== "undefined" && Object.keys(days.days).length) > 0) &&
                                                    Object.keys(days.days).map((key) => {
                                                        if (key === activeDayPostSchedule) {
                                                            return days.days[key].times.map((time, indexTime) => {
                                                                return (
                                                                    <li key={indexTime} onClick={() => handelOnClickSelectTime(time)}>
                                                                        <div
                                                                            className={`item-times-send-modal-select-time ${time.selectable ? '' : 'disabled-time'}
                                                                                ${(Object.keys(activeSelectTablePostSchedule).length > 0 && activeSelectTablePostSchedule.id === time.id) ? 'select' : ''}`}>
                                                                            <div>
                                                                                <span>{time.cost}</span>
                                                                            </div>
                                                                            <div>
                                                                                <span>{time.time}</span>
                                                                                <div className={'border-checked-box-item-send-modal-select-time'}>
                                                                                    <div
                                                                                        className={'body-checked-box-item-send-modal-select-time'}/>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                );
                                                            });
                                                        } else return '';
                                                    })
                                                    }*/}
                                                    {
                                                        _(days.days).find((day, key) => key === activeDayPostSchedule).times && _(days.days).find((day, key) => key === activeDayPostSchedule).times.map(time => (
                                                            <li key={time.id} onClick={() => handelOnClickSelectTime(time)}>
                                                                <div
                                                                    className={`item-times-send-modal-select-time ${time.selectable ? '' : 'disabled-time'} ${(_.size(activeSelectTablePostSchedule) && activeSelectTablePostSchedule.id === time.id) ? 'select' : ''}`}>
                                                                    <div>
                                                                        <span>{time.cost}</span>
                                                                    </div>
                                                                    <div>
                                                                        <span>{time.time}</span>
                                                                        <div className={'border-checked-box-item-send-modal-select-time'}>
                                                                            <div className={'body-checked-box-item-send-modal-select-time'}/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </React.Fragment>
                                    </div>
                                </div>
                            </CSSTransition>
                        </SwitchTransition>
                        : ''

                                        
                        :<LoaderModals/>}
                </Modal.Body>
                <Modal.Footer>
                    <Row className={'w-100 m-auto'}>
                        <Col xs={12}>
                            <div className={'description-footer-time-selected'}>
                                <h6>توجه !</h6>
                                <p>سفارش ها بین بازه انتخاب شده به دست شما خواهد رسید. جهت تنظیم بهینه ارسال ها تعیین زمان خاصی از
                                    بازه انتخاب شده امکان پذیر نمیباشد.</p>
                            </div>
                        </Col>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green'} block onClick={handleSubmit}>
                                <span>تایید</span>
                            </Button>
                        </Col>
                        <Col xs={6} className={'mt-1'}>
                            <Button variant="success" className={'base-btn-green-border'} block onClick={handleClose}>
                                <span>انصراف</span>
                            </Button>
                        </Col>

                    </Row>
                </Modal.Footer>
            </BaseModal>
        </React.Fragment>
    )
};

export default memo(EditOrderDeliveryDateTimeModal);
